import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

/** Envoie un beacon anonyme de visite à chaque changement de page (stats admin). */
export default function VisitTracker() {
    const { pathname } = useLocation();
    useEffect(() => {
        api.post("/track-visit", { path: pathname }).catch(() => {});
    }, [pathname]);
    return null;
}
